import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingBag, Heart } from 'lucide-react';
import { Button } from './ui/button';
import { useWishlist } from '../context/WishlistContext';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { wishlistCount } = useWishlist();

  const navLinks = [
    { path: '/', label: 'Início' },
    { path: '/catalogo', label: 'Catálogo' },
    { path: '/marcas', label: 'Marcas' },
    { path: '/sobre', label: 'Sobre' },
    { path: '/contato', label: 'Contato' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-[#0A0A0A] pointer-events-auto" data-testid="main-header">
      <div className="container mx-auto px-6 md:px-12 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center touch-manipulation" data-testid="header-logo">
            <object
              data="/logo-disneylandia.svg"
              type="image/svg+xml"
              className="h-10 md:h-11 w-auto pointer-events-none"
              aria-label="Disneylândia Cosméticos e Presentes"
            >
              Disneylândia
            </object>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
                  isActive(link.path)
                    ? 'bg-white text-[#0A0A0A]'
                    : 'text-gray-300 hover:text-white hover:bg-white/10'
                }`}
                data-testid={`nav-link-${link.path.replace('/', '') || 'home'}`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* Botão Favoritos */}
            <Link to="/favoritos" className="relative">
              <Button 
                variant="ghost"
                className="text-gray-300 hover:text-white hover:bg-white/10 rounded-full px-4 font-semibold text-sm transition-all duration-200"
                data-testid="header-favorites-btn"
              >
                <Heart size={16} className={wishlistCount > 0 ? "text-red-400 fill-red-400" : ""} />
                {wishlistCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#EA1266] text-white text-xs rounded-full flex items-center justify-center font-bold">
                    {wishlistCount}
                  </span>
                )}
              </Button>
            </Link>
            
            <Link to="/orcamento">
              <Button 
                className="ml-2 bg-[#EA1266] hover:bg-[#d00f58] text-white rounded-full px-6 font-semibold text-sm shadow-lg shadow-pink-500/25 hover:shadow-pink-500/40 transition-all duration-200"
                data-testid="header-quote-btn"
              >
                <ShoppingBag size={16} className="mr-2" />
                Pedir Orcamento
              </Button>
            </Link>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2.5 hover:bg-white/10 rounded-full transition-all text-white touch-manipulation active:scale-95"
            data-testid="mobile-menu-btn"
            type="button"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-1 border-t border-white/10 pt-4" data-testid="mobile-nav">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-5 py-3 rounded-xl font-semibold text-sm transition-all ${
                  isActive(link.path)
                    ? 'bg-white text-[#0A0A0A]'
                    : 'text-gray-300 hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* Favoritos - Mobile */}
            <Link to="/favoritos" onClick={() => setIsMenuOpen(false)}>
              <Button 
                variant="outline" 
                className="w-full border-[#EA1266] text-[#EA1266] hover:bg-pink-50 rounded-full mt-2 font-semibold touch-manipulation active:scale-95 transition-all relative"
              >
                <Heart size={16} className={`mr-2 ${wishlistCount > 0 ? "fill-[#EA1266]" : ""}`} />
                Favoritos
                {wishlistCount > 0 && (
                  <span className="ml-2 bg-[#EA1266] text-white text-xs px-2 py-0.5 rounded-full font-bold">
                    {wishlistCount}
                  </span>
                )}
              </Button>
            </Link>
            
            <Link to="/orcamento" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-[#EA1266] hover:bg-[#d00f58] active:bg-[#b80d4a] text-white rounded-full mt-2 font-semibold shadow-lg shadow-pink-500/25 touch-manipulation active:scale-95 transition-all">
                <ShoppingBag size={16} className="mr-2" />
                Pedir Orcamento
              </Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};
